module.exports = __webpack_public_path__ + "static/media/soap-honey-comb-arrangement.3d94211b.jpg";